<template>
  <div>
    <div class="map">
      <Facets />
      <div class="card">
        <div class="table-title">
          Tabelarische Ansicht
        </div>
        <div class="table-count">
          {{ markers.length }}
          &nbsp;
          <span v-if="markers.length === 1">
            Eintrag
          </span>
          <span v-else>
            Einträge
          </span>

          <div class="table-nav">
            <a class="table-nav-item" @click="page -= 1" v-if="page > 0">
              zurück
            </a>
            <span class="table-nav-item">
              {{ page + 1 }}
            </span>
            <a class="table-nav-item" @click="page += 1" v-if="page+1 < markers.length / size">
              weiter
            </a>
          </div>
        </div>
        <div class="table-content">
          <table>
            <tr>
              <th></th>
              <th>Titel</th>
              <th>Stadtteil</th>
              <th>Erstellt am</th>
            </tr>
            <tr
              v-for="(marker, i) in recentMarkers"
              :key="i"
              v-if="i >= page * size && i < (page+1) * size"
              @click="show(marker)"
              class="cursor-pointer"
            >
              <td>
                <img
                  class="table-preview"
                  :src="'https://map.linguasnapp.uni-hamburg.de/Public/Map/Image/' + marker.UniqueNo"
                  alt=""
                >
              </td>
              <td>{{ marker.Title }}</td>
              <td>
                <span v-if="marker.DistrictName !== 'None'">
                  {{ marker.DistrictName }}
                </span>
              </td>
              <td>{{ marker.DateString }}</td>
            </tr>
          </table>
        </div>
        <div class="table-count">
          {{ markers.length }}
          &nbsp;
          <span v-if="markers.length === 1">
            Eintrag
          </span>
          <span v-else>
            Einträge
          </span>

          <div class="table-nav">
            <a class="table-nav-item" @click="page -= 1" v-if="page > 0">
              zurück
            </a>
            <span class="table-nav-item">
              {{ page + 1 }}
            </span>
            <a class="table-nav-item" @click="page += 1" v-if="page+1 <= markers.length / size">
              weiter
            </a>
          </div>
        </div>
      </div>
    </div>

    <modal
      name="hello-world"
      height="auto"
      class="table-modal"
    >
      <div
        :class="{
          'table-modal-content': !showPhoto,
        }"
      >
        <div
          v-show="showPhoto"
          class="relative"
          @click="showPhoto = false"
        >
          <div
            class="absolute z-10 w-8 h-8 m-2 right-0 bg-gray-100 flex justify-center items-center rounded opacity-75 hover:opacity-100 cursor-pointer"
          >
            <i class="material-icons">close</i>
          </div>
          <img
            :src="'https://map.linguasnapp.uni-hamburg.de/Public/Map/Image/' + photoId"
            alt=""
            class="h-full"
          />
        </div>
        <div v-show="!showPhoto" v-html="contentString">
        </div>
      </div>
    </modal>

    <div>
      <Districts />
      <Criteria />
    </div>
  </div>
</template>

<script>
import Criteria from './map/criteria/Criteria';
import Districts from './map/districts/Districts';
import Facets from './map/facets/Facets';
import axios from 'axios';

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: 'Table',
    components: { Districts, Facets, Criteria },
    data () {
        return {
            page: 0,
            size: 25,
            activeMarker: { },
            contentString: 'aaa',
            showPhoto: false,
            photoId: '',
        };
    },
    mounted () {
        this.updateMarkers();
        this.hide();
    },
    computed: {
        ...mapState({
            markers: (state) => state.facets.markers,
        }),
        ...mapGetters({
            recentMarkers: 'facets/recentMarkers',
        }),
    },
    methods: {
        ...mapActions('facets', [
            'updateMarkers',
        ]),
        show (marker) {
            this.showPhoto = false;
            this.activeMarker = marker;
            this.$modal.show('hello-world', {}, { height: 'auto' });

            this.contentString =
                '<div class="photoTitle">'
                + '<div style="display: flex">'
                + '<div class="lds-ellipsis" style="margin: auto">'
                + '<div></div>'
                + '<div></div>'
                + '<div></div>'
                + '<div></div>'
                + '</div>'
                + '</div>';

            const base = 'https://map.linguasnapp.uni-hamburg.de';
            this.photoId = marker.UniqueNo;
            axios.post(base + '/Public/Map/GetPhoto/' + marker.UniqueNo).then((response) => {
                this.contentString = response.data;
                setTimeout(() => {
                    let photo = document.getElementById('divPhotoImage');
                    photo.addEventListener('click', () => {
                        this.showPhoto = true;
                    });
                }, 0);
            });
        },
        hide () {
            this.$modal.hide('hello-world');
        }
    },
    watch: {
        markers () {
            this.page = 0;
            this.size = 25;
        }
    }
};
</script>

<style scoped>
.map {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

@media (max-width: 800px) {
  .map {
    flex-direction: column-reverse;
  }
}

.card {
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  padding: 30px 13px;
  flex-grow: 1;
}

.card table {
  width: 100%;
  height: 100%;
  border-collapse: collapse;
}

.card th, .card td {
  border-right: 1px solid #ddd;
  padding: 10px 18px;
  height: 48px;
}

.card th:last-child, td:last-child {
  border: none;
}

.card th {
  font-size: 19px;
  line-height: 20px;
  font-weight: bold;
  font-family: TheSansUHH-Caps, sans-serif;
  text-align: left;
}

.table-title {
  font-size: 19px;
  line-height: 20px;
  font-weight: bold;
  margin-left: 8px;
  font-family: TheSansUHH-Caps, sans-serif;
  text-align: left;
}

.table-preview {
  width: 32px;
}

.table-content {
  margin-top: 20px;
}

.table-count {
  margin-top: 20px;
  margin-left: 10px;
  display: flex;
}

.table-nav {
  margin-left: auto;
}

.table-nav-item {
  margin: 0 10px;
  user-select: none;
}
a.table-nav-item {
  cursor: pointer;
}

.table-modal-content {
  padding: 10px 20px;
  height: 530px;
}
</style>
